import { render } from "./setMeal.vue?vue&type=template&id=82955cec&scoped=true"
import script from "./setMeal.vue?vue&type=script&lang=js"
export * from "./setMeal.vue?vue&type=script&lang=js"

import "./setMeal.vue?vue&type=style&index=0&id=82955cec&lang=less&scoped=true"

import exportComponent from "/disk2/var/jenkins/workspace/prod__cosmic-mall-h5-entry/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82955cec"]])

export default __exports__